export const evaluationTests = [
  {
    id: 'dynamicBalance',
    name: 'Equilíbrio Dinâmico',
    description: 'Caminhar em linha reta nos blocos, alternando os pés.',
    scores: [
      'Incapaz de caminhar em linha reta',
      'Caminha com apoio constante',
      'Caminha com mínimo apoio',
      'Caminha independentemente'
    ]
  },
  {
    id: 'staticBalance',
    name: 'Equilíbrio Estático',
    description: 'Permanecer em pé sobre um dos pés.',
    scores: [
      'Incapaz de permanecer em pé sobre um pé',
      'Permanece com apoio constante',
      'Permanece com mínimo apoio',
      'Permanece independentemente'
    ]
  },
  {
    id: 'motorCoordination',
    name: 'Coordenação Motora – Acerto de Alvo',
    description: 'Lançamento de bola ao alvo a uma distância moderada.',
    scores: [
      'Incapaz de lançar na direção do alvo',
      'Lança com apoio constante',
      'Lança com mínimo apoio',
      'Acerta o alvo independentemente'
    ]
  },
  {
    id: 'bilateralIntegration',
    name: 'Integração Bilateral – Transferência de Objetos',
    description: 'Transferência de objetos de uma mão para a outra.',
    scores: [
      'Incapaz de transferir objetos entre as mãos',
      'Transfere com apoio constante',
      'Transfere com mínimo apoio',
      'Transfere independentemente'
    ]
  },
  {
    id: 'spatialPerception',
    name: 'Percepção Espacial – Orientação no Espaço',
    description: 'Guiar o guidão com roda por um trajeto com obstáculos.',
    scores: [
      'Incapaz de percorrer o trajeto',
      'Percorre com apoio constante',
      'Percorre com mínimo apoio',
      'Percorre o labirinto independentemente'
    ]
  },
  {
    id: 'bodySchema',
    name: 'Esquema Corporal',
    description: 'Identificar partes do corpo (olhos, nariz, boca).',
    scores: [
      'Incapaz de identificar partes do corpo',
      'Identifica com apoio constante',
      'Identifica com mínimo apoio',
      'Identifica independentemente'
    ]
  },
  {
    id: 'forceControl',
    name: 'Controle de Força',
    description: 'Apertar uma bola de borracha com diferentes intensidades.',
    scores: [
      'Incapaz de controlar a força',
      'Controla com apoio constante',
      'Controla com mínimo apoio',
      'Controla independentemente'
    ]
  }
];

export const calculateTotalScore = (scores) => {
  return Object.values(scores).reduce((sum, score) => {
    const numericScore = Number(score);
    return sum + (Number.isInteger(numericScore) ? numericScore : 0);
  }, 0);
};

export const getInterpretation = (totalScore) => {
  if (totalScore >= 0 && totalScore <= 7) {
    return 'Desenvolvimento abaixo da média';
  } else if (totalScore >= 8 && totalScore <= 14) {
    return 'Desenvolvimento intermediário';
  } else if (totalScore >= 15 && totalScore <= 21) {
    return 'Desenvolvimento acima da média';
  }
  return 'Pontuação inválida';
};